import { Menu, Bell } from 'lucide-react';

interface HeaderProps {
  onMobileMenuToggle: () => void;
}

export default function Header({ onMobileMenuToggle }: HeaderProps) {
  return (
    <header className="h-14 flex items-center justify-between px-4 md:px-6 backdrop-blur-xl bg-zinc-950/70 border-b border-zinc-800 shrink-0">
      <button
        onClick={onMobileMenuToggle}
        className="lg:hidden p-2 -ml-2 rounded-lg hover:bg-zinc-800 transition-colors"
        data-testid="mobile-menu-toggle"
        aria-label="Open navigation menu"
      >
        <Menu className="w-5 h-5 text-zinc-400" />
      </button>
      <div className="hidden lg:block" />
      <div className="flex items-center gap-2">
        <button
          className="p-2 rounded-lg hover:bg-zinc-800 transition-colors relative"
          data-testid="notifications-btn"
          aria-label="Notifications"
          disabled
        >
          <Bell className="w-5 h-5 text-zinc-400" />
        </button>
      </div>
    </header>
  );
}
